import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getCrossConnections, getInterfaceCrossConnections, getLockerCrossConnections, getSiteCrossConnections, patchCrossConnection, postCrossConnection, removeCrossConnection } from './data';
import { errorReceiveCreateCrossConnection, errorReceiveCrossConnections, errorReceiveInterfaceCrossConnections, errorReceiveLockerCrossConnections, errorReceiveModifyCrossConnection, errorReceiveRemoveCrossConnection, errorReceiveSiteCrossConnections, failedReceiveCreateCrossConnection, failedReceiveCrossConnections, failedReceiveInterfaceCrossConnections, failedReceiveLockerCrossConnections, failedReceiveModifyCrossConnection, failedReceiveRemoveCrossConnection, failedReceiveSiteCrossConnections, receiveCreateCrossConnection, receiveCrossConnections, receiveInterfaceCrossConnections, receiveLockerCrossConnections, receiveModifyCrossConnection, receiveRemoveCrossConnection, receiveSiteCrossConnections } from './slice';
export function* requestCreateCrossConnection(action) {
    try {
        const { description, sourcePort, targetPort } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postCrossConnection, organization, description, sourcePort, targetPort);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveCreateCrossConnection());
            yield put(appDanger(t('ERROR_REQUEST_CREATE_CROSS_CONNECTION', {
                ns: 'Common'
            })));
        }
        else if (data) {
            yield put(receiveCreateCrossConnection(data));
            yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_CROSS_CONNECTION', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_CREATE_CROSS_CONNECTION', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveCreateCrossConnection());
    }
}
export function* requestCrossConnections() {
    try {
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getCrossConnections, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveCrossConnections());
        }
        else if (data) {
            yield put(receiveCrossConnections(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_CROSS_CONNECTIONS', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveCrossConnections());
    }
}
export function* requestInterfaceCrossConnections(action) {
    try {
        const { deviceID, interfaceID } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getInterfaceCrossConnections, organization, deviceID, interfaceID);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveInterfaceCrossConnections());
        }
        else if (data) {
            yield put(receiveInterfaceCrossConnections(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_INTERFACE_CROSS_CONNECTIONS', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveInterfaceCrossConnections());
    }
}
export function* requestLockerCrossConnections(action) {
    try {
        const { deviceID } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getLockerCrossConnections, organization, deviceID);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveLockerCrossConnections());
        }
        else if (data) {
            yield put(receiveLockerCrossConnections(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_LOCKER_CROSS_CONNECTIONS', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveLockerCrossConnections());
    }
}
export function* requestModifyCrossConnection(action) {
    try {
        const { description, vcid } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchCrossConnection, organization, description, vcid);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveModifyCrossConnection());
            yield put(appDanger(t('ERROR_REQUEST_MODIFY_CROSS_CONNECTION', {
                ns: 'Common'
            })));
        }
        else if (data) {
            yield put(receiveModifyCrossConnection(data));
            yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_CROSS_CONNECTION', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('SUCCESS_REQUEST_MODIFY_CROSS_CONNECTION', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveModifyCrossConnection());
    }
}
export function* requestRemoveCrossConnection(action) {
    try {
        const { vcid } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeCrossConnection, organization, vcid);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveRemoveCrossConnection());
            yield put(appDanger(t('ERROR_REQUEST_REMOVE_CROSS_CONNECTION', {
                ns: 'Common'
            })));
        }
        else if (data) {
            yield put(receiveRemoveCrossConnection(data));
            yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_CROSS_CONNECTION', {
                ns: 'Common'
            })));
        }
        else {
            throw new Error(t('FAILED_REQUEST_REMOVE_CROSS_CONNECTION', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveCrossConnection());
    }
}
export function* requestSiteCrossConnections(action) {
    try {
        const { locationSlug } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getSiteCrossConnections, organization, locationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveSiteCrossConnections());
        }
        else if (data) {
            yield put(receiveSiteCrossConnections(data));
        }
        else {
            throw new Error(t('FAILED_REQUEST_SITE_CROSS_CONNECTIONS', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveSiteCrossConnections());
    }
}
export function* watchRequestCreateCrossConnection() {
    yield takeLatest('crossConnections/requestCreateCrossConnection', requestCreateCrossConnection);
}
export function* watchRequestCrossConnections() {
    yield takeLatest('crossConnections/requestCrossConnections', requestCrossConnections);
}
export function* watchRequestInterfaceCrossConnections() {
    yield takeLatest('crossConnections/requestInterfaceCrossConnections', requestInterfaceCrossConnections);
}
export function* watchRequestLockerCrossConnections() {
    yield takeLatest('crossConnections/requestLockerCrossConnections', requestLockerCrossConnections);
}
export function* watchRequestModifyCrossConnection() {
    yield takeLatest('crossConnections/requestModifyCrossConnection', requestModifyCrossConnection);
}
export function* watchRequestRemoveCrossConnection() {
    yield takeLatest('crossConnections/requestRemoveCrossConnection', requestRemoveCrossConnection);
}
export function* watchRequestSiteCrossConnections() {
    yield takeLatest('crossConnections/requestSiteCrossConnections', requestSiteCrossConnections);
}
